import { render, staticRenderFns } from "./LogoLight.vue?vue&type=template&id=2695fcaf&"
import script from "./LogoLight.vue?vue&type=script&lang=js&"
export * from "./LogoLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports